module.exports = __webpack_public_path__ + "media/images/delete-4234fe252dd8997c4552d8d430c145b3.svg";